import React, { useContext, useState, useEffect } from "react"
// import { Link } from "react-router-dom"
import { FaTimes } from "react-icons/fa"
import { AudioContext } from "../context/audioContext"

import audios from "../data/audios"

const Purchase = () => {
  const [music, setMusic] = useContext(AudioContext)
  let beat

  if (music) {
    const audio = audios.filter((o) => o.id === music.purchaseId)
    beat = audio[0]
  }
  // const [msg, setMsg] = useState(null)
  // const [formData, setFormData] = useState({
  //   Name: "",
  //   email: "",
  //   tel: "",
  // })

  const closeComponent = () => {
    setMusic({
      ...music,
      purchaseId: "",
    })
    // setFormData(null)
  }
  useEffect(() => {
    if (music && music.purchaseId) {
      document.body.classList.add("no-scrolling")
    }
  }, [])

  // const handleChange = (e) => {
  //   const { name, value } = e.target
  //   setFormData({
  //     ...formData,
  //     id: music && music.purchaseId,
  //     title: beat && beat.title,
  //     src: beat && beat.src,
  //     [name]: value,
  //   })
  //   console.log(formData)
  // }

  // const handleSubmit = (e) => {
  //   e.preventDefault()
  //   setMsg("Your Order was submitted successfully")
  // }

  return (
    <>
      {music && music?.purchaseId && (
        <section className="purchase">
          {beat && (
            <div>
              <h1>{beat?.title}</h1>
              {/* <p>Purchase this beat</p>
              {beat?.cost && <p className="cost">{beat?.cost} Tshs</p>} */}
              <p>Contact SOZ to purchase this beat</p>
              <ul>
                <li>
                  <a href="tel:+255753282902">+255 753 282 902</a>
                </li>
                <li>
                  <a href="tel:+255718506063">+255 718 506 063</a>
                </li>
                <li>
                  <a href="http://wa.me/255718506063">WhatsApp</a>
                </li>
                <li>
                  <a href="emailto:sozthegovt@gmail.com">
                    sozthegovt@gmail.com
                  </a>
                </li>
              </ul>
              {/* <form onSubmit={(e) => handleSubmit(e)}>
                <div className="form-group">
                  <label htmlFor="Name">
                    Your Name
                    <input
                      type="text"
                      name="Name"
                      placeholder="Please enter your name"
                      onChange={(e) => handleChange(e)}
                    />
                  </label>
                </div>
                <div className="form-group">
                  <label htmlFor="Email">
                    Email Address
                    <input
                      type="email"
                      name="email"
                      placeholder="email@example.com"
                      onChange={(e) => handleChange(e)}
                    />
                  </label>
                </div>
                <div className="form-group">
                  <label htmlFor="tel No">
                    Tel No.
                    <input
                      type="text"
                      name="tel"
                      placeholder="+255 111 222 333"
                      onChange={(e) => handleChange(e)}
                    />
                  </label>
                </div>
                <div className="btns">
                  <button type="submit">Submit</button>
                  
                </div>
              </form> */}
              {/* {formData && (
                <>
                  {formData.Name && (
                    <h2>
                      Hey {formData.Name}, confirm them details before sending
                      this... JK
                    </h2>
                  )}
                  <p>{formData.email}</p>
                  <p>{formData.tel}</p>
                  <p></p>
                </>
              )}
              {msg && <p>{msg}</p>} */}
              <button className="close" onClick={closeComponent}>
                <FaTimes className="icon" />
              </button>
            </div>
          )}
        </section>
      )}
    </>
  )
}

export default Purchase
